<template>
    <div
        :class="[
            {
                'has-inline-label': hasInlineLabel,
                'has-placeholder': !!placeholder,
            },
            parentClass,
            'form-group',
        ]"
    >
        <label
            :for="uniqueId"
            :class="[
                {
                    'move-label-to-top': moveLabelToTop,
                },
                'form-label',
            ]"
        >
            {{ label }}
        </label>
        <div class="input-group">
            <slot
                v-if="$slots.prepend"
                name="prepend"
            />
            <input
                v-bind="$attrs"
                @change="handleChange($event.target.value)"
                @focusin="focus = true"
                @focusout="focus = false"
                :id="uniqueId"
                :placeholder="inputPlaceholder"
                :step="step"
                :type="type"
                :value="inputValue"
                :class="[
                    {
                        'move-label-to-top': moveLabelToTop,
                    },
                    'form-control',
                ]"
                pattern="[-+]?[0-9]*[.]?[0-9]+"
            >
            <slot
                v-if="$slots.append"
                name="append"
            />
        </div>
        <slot />
    </div>
</template>

<script>
    import Config from '../../config';

    export default {
        name: 'FormInputNumber',
        inheritAttrs: false,
        props: {
            value: {
                type: [String, Number],
                default: '',
            },
            type: {
                type: String,
                default: 'text',
            },
            label: {
                required: true,
                type: String,
            },
            placeholder: {
                type: String,
                default: '',
            },
            parentClass: {
                type: String,
                default: '',
            },
            inlineLabel: {
                type: Boolean,
                default: Config.options.inlineLabel,
            },
            precision: {
                type: Number,
                default: Config.options.precision,
            },
            step: {
                type: String,
                default: 'any',
            },
        },
        data() {
            return {
                focus: false,
                inputValue: '',
                hasInlineLabel: this.inlineLabel,
            };
        },
        computed: {
            moveLabelToTop() {
                return this.placeholder || this.focus || this.inputValue !== '';
            },
            uniqueId() {
                return this.$id('pacos-input-number');
            },
            inputPlaceholder() {
                return this.hasInlineLabel
                    ? this.placeholder || this.label
                    : this.placeholder;
            },
        },
        methods: {
            async handleChange(value) {
                let newValue = value.toString().trim().replace(',', '.');

                if (!Number.isNaN(Number(newValue)) && newValue !== '') {
                    newValue = +Number(newValue).toFixed(this.precision);
                } else {
                    newValue = '';
                }

                // empty the input value so the new value will always update
                this.inputValue = '';
                await this.$nextTick();

                this.inputValue = newValue;
                this.$emit('input', newValue);
            },
        },
        watch: {
            value: {
                immediate: true,
                handler(value) {
                    this.inputValue = value || value === 0
                        ? +Number(value).toFixed(this.precision)
                        : '';
                },
            },
        },
    };
</script>
